<style lang='less' scoped>
@import '../base.less';
</style>
<template>
  <div>
    <!-- SEARCH -->
    <Row>
      <Col span="24">


        <Card class="margin-bottom-10">

          <video id="in" src="../../assets/audios/in.wav" style="display:none"></video>
          <Form inline>
            <h2 style="color: #000;margin-bottom: 5px">操作提示，请您阅读!</h2>
            <h2 style="color: red;margin-bottom: 5px">搜索没有选择状态时,默认搜索待处理的订单</h2>
          </Form>
          <Form inline>
            <FormItem class='margin-bottom-0'>
              <Select multiple v-model='searchConf.pay_channels_ids' clearable
                      :placeholder="$t('收款通道') " style='width:120px'>
                <Option :key="key" :value="value.id.toString()"
                        v-for="(value, key) in paramsArray.payChannelArray"> {{ value.title }}
                </Option>
              </Select>
            </FormItem>

            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.recharge_money_min' :placeholder="$t('金额下限') "></Input>
            </FormItem>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.recharge_money_max' :placeholder="$t('金额上限') "></Input>
            </FormItem>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.ip' :placeholder="$t('用户IP') "></Input>
            </FormItem>
          </Form>
          <div style="border-bottom: 1px solid lightgray;padding-bottom:10px;margin-bottom: 10px;margin-top: 5px"></div>
          <Form inline>
            <FormItem style="margin-bottom: 0">
              <DatePicker type="datetimerange" :options="timeOptions" :value='searchConf.searchTime'
                          @on-change='timeChange' format="yyyy-MM-dd HH:mm:ss"
                          :placeholder="$t('选择时间')" style="width: 280px">
              </DatePicker>
            </FormItem>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.username' :placeholder="$t('用户名') "></Input>
            </FormItem>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.serial_num' :placeholder="$t('订单号') "></Input>
            </FormItem>
            <FormItem class='margin-bottom-0'>
              <Select v-model='searchConf.status' clearable :placeholder="$t('状态') "
                      style='width:120px' @on-change='changeSelectStatus'>
                <Option :value="'0'">{{ $t('未处理') }}</Option>
                <Option :value="'1'">{{ $t('挂起') }}</Option>
                <Option :value="'2'">{{ $t('无效') }}</Option>
                <Option :value="'4'">{{ $t('成功') }}</Option>
                <Option :value="'5'">{{ $t('全部') }}</Option>
              </Select>
            </FormItem>



            <FormItem class="margin-bottom-0">
              <Button type="primary" @click="search">{{ $t('find_button') }}</Button>
            </FormItem>

            <FormItem label=" 自动刷新" style="margin-left: 40px; width: 150px">
              <i-Switch id="switch" v-model="timerIsOpen" @on-change="openTimeGetList(10000)"
                        size="large">
                <span slot="open">开启</span>
                <span slot="close">关闭</span>
              </i-Switch>
            </FormItem>
            <ButtonGroup id="btn">
              <Button id="one" :disabled="disabled" :class="{active: countDown === 10000}"
                      @click="openTimeGetList(10000)">10秒
              </Button>
              <Button id="two" :disabled="disabled" :class="{active: countDown === 15000}"
                      @click="openTimeGetList(15000)">15秒
              </Button>
              <Button id="three" :disabled="disabled" :class="{active: countDown === 30000}"
                      @click="openTimeGetList(30000)">30秒
              </Button>
              <Button id="four" :disabled="disabled" :class="{active: countDown === 60000}"
                      @click="openTimeGetList(60000)">1分钟
              </Button>
            </ButtonGroup>

            <FormItem label="自动入款" style="margin-left: 40px; width: 170px">
              <i-Switch id="switch" size="large"  v-model="paramsArray.is_auto_recharge==1"  @on-change="changeIsAutoRecharge">


                <span slot="open">开启</span>
                <span slot="close">关闭</span>
              </i-Switch>
            </FormItem>

          </Form>
        </Card>
      </Col>
    </Row>        <!--    -->
    <Row>
      <Col span='24'>
        <Card>
          <!-- ADDBUTTON -->
          <!--          <div class='margin-bottom-15'>-->
          <!--            <Button type='primary' v-has="'financeManage/rechargePending/add'" @click='preAdd' icon='md-add'>-->
          <!--              {{ $t('add_button') }}-->
          <!--            </Button>-->
          <!--          </div>-->
          <!-- DATA -->
          <div>
            <Table @on-sort-change="sortChange" :loading='listLoading' :columns='columnsList' :data='tableData'
                   border></Table>
          </div>
          <!-- PAGE -->
          <div class='margin-top-15' style='text-align: center'>
            <Page :total='tableShow.listCount' :current='tableShow.currentPage' :page-size='tableShow.pageSize'
                  @on-change='changePage' @on-page-size-change='changeSize'
                  :page-size-opts='[10,20,30,40,50,100,200,300]' show-elevator show-sizer show-total></Page>
          </div>
        </Card>
      </Col>
    </Row>
    <!-- windowAddEdit -->
    <Modal v-model="windowChange.show" width="668" :styles="{top: '30px'}" @on-visible-change="windowChangeCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ $t('调整') }}</span>
      </p>
      <Form ref="windowChangeForm" :rules="windowChangeValidate" :model="windowChangeItem" :label-width="120"
            label-position="left">
        <FormItem label='充值赠送金额' prop='send_money'>
          <Input v-model='windowChangeItem.send_money' :placeholder="$t('请输入充值赠送金额')"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="windowChangeCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowChangeSubmit" :loading="windowChange.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <!--    -->
    <Modal v-model="windowPics.show" width="auto" :styles="{top: '30px'}" @on-visible-change="windowPicsCancel">

      <div v-for="(url, index) in windowPicsItem.pics" :key="index">
        <img :src=windowPicsItem.pics[index] style="max-width: 800px;max-height: 800px"></img>
      </div>

    </Modal>

  </div>
</template>
<script>
import {
  getList,
  add,
  del,
  lock,
  getWindowsParams,
  changeStatus,
  changeSend,
  changeIsAutoRecharge
} from '@/api/financeManage/rechargePending'
import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'

export default {
  name: 'interface_list',
  data () {
    return {
      timeOptions: {
        shortcuts: [{
          text: '今天',
          value () {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value () {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value () {
              return lastMonthDate()
            }
          },
        ]
      },
      columnsList: [{
        title: this.$t('单号'),
        key: 'serial_num',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('会员帐号'),
        key: 'username',

        minWidth: 120,
        align: 'center'
      }
        // , {
        //   title: this.$t('充值币种/汇率/兑换前充值金额'),
        //   key: 'rechargeCEM',
        //   minWidth: 200,
        //   align: 'center'
        // }
        , {
          title: this.$t('充值金额'),
          key: 'recharge_money',

          minWidth: 120,
          align: 'center'
        }, {
          title: this.$t('充值赠送'),
          key: 'send_money',

          minWidth: 120,
          align: 'center'
        }, {
          title: this.$t('发起时间'),
          key: 'add_time',

          minWidth: 120,
          align: 'center'
        }, {
          title: this.$t('收款通道'),
          key: 'rechargePayChannel',

          minWidth: 120,
          align: 'center'
        }, {
          title: this.$t('查看凭证'),
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            let vm = this
            return h('div', [h('Button', {
              props: {
                type: 'error',
                size: 'small'
              },
              style: {
                margin: '0 5px'
              },
              on: {
                'click': () => {
                  let vm = this
                  console.log('456')
                  vm.windowPicsItem.pics = JSON.parse(params.row.pics)
                  vm.windowPics.show = true
                }
              }
            }, this.$t('查看凭证')),])
          }
        }, {
          title: this.$t('附言'),
          key: 'remark',

          minWidth: 120,
          align: 'center'
        }, {
          title: this.$t('今日首充'),
          align: 'center',
          minWidth: 80,

          key: 'isFirstRechargeToday',
          render: (h, params) => {
            return h('div', [
              h('span', {
                style: {
                  color: params.row.isFirstRechargeToday ? '#ed4014' : '#19be6b',
                  borderRadius: '11px',
                  border: params.row.isFirstRechargeToday ? '1px solid #ed4014' : '1px solid #19be6b',
                  display: '',
                  height: '25px',
                  width: '70%',
                  lineHeight: '25px',
                  margin: 'auto',
                  padding: '3px'
                },
              }, params.row.isFirstRechargeToday ? this.$t('今日首充') : this.$t('非首充')),
            ])
          }
        }, {
          title: this.$t('状态'),
          align: 'center',
          minWidth: 80,
          key: 'status',
          render: (h, params) => {
            return h('div', [
              h('span', {
                style: {
                  color: params.row.status != 4 ? '#ed4014' : '#19be6b',
                  borderRadius: '11px',
                  border: params.row.status != 4 ? '1px solid #ed4014' : '1px solid #19be6b',
                  display: '',
                  height: '25px',
                  width: '70%',
                  lineHeight: '25px',
                  padding: '3px'
                },
              }, params.row.status == 0 ? this.$t('待处理') : params.row.status == 1 ? this.$t('挂起') : params.row.status == 2 ? this.$t('无效') : params.row.status == 3 ? this.$t('无效') : this.$t('成功')),
            ])
          }
        }, {
          title: this.$t('操作'),
          align: 'center',
          minWidth: 200,
          render: (h, params) => {
            let vm = this
            return h('div', [
              h('Poptip', {
                props: {
                  confirm: true,
                  title: this.$t('确定要充值用户?'),
                  transfer: true
                },
                on: {
                  'on-ok': () => {

                    changeStatus(4, params.row.id).then(response => {
                      this.$Message.success(response.data.msg)
                      this.getList()
                    })
                    params.loading = false

                  }
                }
              }, [h('Button', {
                style: {
                  margin: '0 2px',
                  display: params.row.status == 2 ? 'none' : ''
                },
                props: {
                  type: this.$t('primary'),
                  placement: 'top',
                  disabled: params.row.status > 1,
                  size: 'small'
                }
              }, this.$t('入款'))])
              , h('Poptip', {
                props: {
                  confirm: true,
                  title: this.$t('确定该条充值记录[无效]?'),
                  transfer: true
                },
                on: {
                  'on-ok': () => {

                    changeStatus(2, params.row.id).then(response => {
                      this.$Message.success(response.data.msg)
                      this.getList()
                    })
                    params.loading = false

                  }
                }
              }, [
                h('Button', {
                  style: {
                    margin: '0 2px',
                  },
                  props: {
                    type: this.$t('error'),
                    placement: 'top',
                    loading: params.isDeleting,
                    disabled: params.row.status > 1,
                    size: 'small'
                  }
                }, this.$t('取消'))
              ]), h('Poptip', {
                props: {
                  confirm: true,
                  title: this.$t('确定要挂起?'),
                  transfer: true
                },
                on: {
                  'on-ok': () => {
                    changeStatus(1, params.row.id).then(response => {
                      this.$Message.success(response.data.msg)
                      this.getList()
                    })
                    params.loading = false
                  }
                }
              }, [
                h('Button', {
                  style: {
                    margin: '0 2px',
                    display: params.row.status == 2 ? 'none' : ''
                  },
                  props: {
                    type: this.$t('info'),
                    placement: 'top',
                    loading: params.isDeleting,
                    disabled: params.row.status > 0,
                    size: 'small'
                  }
                }, this.$t('挂起'))
              ]),
              h('Poptip', {
                props: {
                  confirm: true,
                  title: this.$t('确定要恢复?'),
                  transfer: true
                },

                on: {
                  'on-ok': () => {
                    changeStatus(0, params.row.id).then(response => {
                      this.$Message.success(response.data.msg)
                      this.getList()
                    })
                    params.loading = false
                  }
                }
              }, [
                h('Button', {
                  style: {
                    margin: '0 2px',
                    display: (params.row.status == 2||params.row.status == 3) ? '' : 'none'
                  },
                  props: {
                    type: this.$t('info'),
                    placement: 'top',
                    loading: params.isDeleting,
                    size: 'small'
                  }
                }, this.$t('恢复'))
              ])])
          }
        }, {
          title: this.$t('充值赠送调整'),
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            let vm = this
            return h('div', [h('Button', {
              props: {
                type: 'primary',
                disabled: params.row.status > 1,
                size: 'small'
              },
              style: {
                margin: '0 5px'
              },
              on: {
                'click': () => {
                  let vm = this
                  this.windowChangeItem.id = params.row.id
                  this.windowChangeItem.send_money = params.row.send_money
                  vm.windowChange.show = true
                }
              }
            }, this.$t('赠送调整')),])
          }
        },{
          title: this.$t('是否幸运充值'),
          align: 'center',
          minWidth: 80,
          key: 'status',
          render: (h, params) => {
            return h('div', [
              h('span', {
                style: {
                  color: params.row.lucky_id > 0 ? '#ed4014' : '#19be6b',
                  borderRadius: '11px',
                  border: params.row.lucky_id > 0 ? '1px solid #ed4014' : '1px solid #19be6b',
                  display: '',
                  height: '25px',
                  width: '70%',
                  lineHeight: '25px',
                  padding: '3px'
                },
              }, params.row.lucky_id > 0  ? this.$t('是') : this.$t('否')),
            ])
          }
        }, {
          title: this.$t('用户IP'),
          key: 'ip',

          minWidth: 120,
          align: 'center'
        }, {
          title: this.$t('存入方式'),
          key: 'rechargeMethod',

          minWidth: 120,
          align: 'center'
        }, {
          title: this.$t('操作员'),
          key: 'admin_name',

          minWidth: 120,
          align: 'center'
        }, {
          title: this.$t('操作时间'),
          key: 'update_time',

          minWidth: 120,
          align: 'center'
        },],
      tableData: [],//用于放LIST数据绑定
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 10,
        listCount: 0
      },
      searchConf: { searchTime: [], }, // 搜索字段
      paramsArray: [],
      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      //弹窗--------------
      windowChange: { //弹窗
        show: false,
        loading: false,
        index: 0
      },

      windowChangeItem: { //弹窗数据绑定
        id: 0
      },
      windowPics: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowPicsItem: {
        pics: []
      },
      windowChangeValidate: {//窗口校验规则
      },
      windowPicsValidate: {//窗口校验规则
      },
      timer: '',
      timerIsOpen: true,
      countDown: 10000,
      //----------------
    }
  },
  created () {
    let vm = this
    this.searchConf.username = this.$route.params.username ? this.$route.params.username : ''
    this.searchConf.status = this.$route.params.username ? '5' : ''
    vm.getList()
    vm.hasRule('financeManage/rechargePending/edit').then(res => {
      vm.buttonShow.edit = res
    })
    vm.hasRule('financeManage/rechargePending/del').then(res => {
      vm.buttonShow.del = res
    })
    vm.hasRule('financeManage/rechargePending/changeStatus').then(res => {
      vm.buttonShow.changeStatus = res
    })
  },
  mounted () {
    this.getWindowsParams()
    if (this.timerIsOpen == true) {
      this.openTimeGetList(10000)
    }
  },
  beforeDestroy () {
    if (this.timer) {
      //如果定时器还在运行 或者直接关闭，不用判断
      clearTimeout(this.timer) //关闭
    }

  },
  methods: {
    preAdd () {
      //let vm = this
      // vm.windowAdd.show = true
    },
    getWindowsParams () {
      getWindowsParams().then(response => {
        this.paramsArray = response.data.data
      })
    },
    changePage (page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize (size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search () {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getList () {
      let vm = this
      vm.listLoading = true
      getList({
        page: vm.tableShow.currentPage,
        size: vm.tableShow.pageSize,
        search: vm.searchConf
      }).then(response => {
        vm.tableData = response.data.data.list
        vm.tableShow.listCount = response.data.data.count
        vm.listLoading = false
        if (response.data.data.pendingCount > 0) {
          let audio = document.getElementById('in')
          audio && audio.play()
        }
      })
    },

    timeChange (datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },
    changeSelectStatus (value) { //时间修改，自动计算尾部时间
      if (value >= 0) {
        this.timerIsOpen = false
      } else {
        this.timerIsOpen = true
        this.openTimeGetList(this.countDown)
      }

    },
    sortChange: function ({ column, key, order }) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    },
    openTimeGetList (time) {//倒计时,去循环GETLIST
      this.countDown = time
      if (this.timer) {
        clearTimeout(this.timer)
      }
      if (this.timerIsOpen == false) {
        return
      }
      this.timer = setTimeout(() => {
        this.openTimeGetList(time)
      }, time)
      this.getList()
    },
    windowChangeCancel (data) {
      if (!data) {
        this.windowChangeItem.id = 0
        this.$refs['windowChangeForm'].resetFields()
        this.windowChange.show = false
        this.windowChange.loading = false
        this.windowChange.index = 0
      }
    },
    windowPicsCancel (data) {
      if (!data) {
        this.windowPicsItem.pics = []
        this.windowPics.show = false
        this.windowPics.loading = false
        this.windowPics.index = 0
      }
    },
    windowChangeSubmit () {
      let vm = this
      vm.$refs['windowChangeForm'].validate((valid) => {
        if (valid) {
          vm.windowChange.loading = true
          changeSend(vm.windowChangeItem).then(response => {
            vm.$Message.success(response.data.msg)
            vm.getList()
            vm.windowChangeCancel()
          }).catch(() => {
            vm.windowChange.loading = false
          })
        }
      })
    },
    changeIsAutoRecharge (isOpen) {
      let vm = this
      let is_auto_recharge=isOpen==true?1:0;
      changeIsAutoRecharge(is_auto_recharge).then(response => {
        vm.$Message.success(response.data.msg)
        this.getWindowsParams();
      })

    },
  }
}
</script>
